import Nav from "../components/Nav";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Process from "../components/Process";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#f9f8f5]">
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Process />
        <FAQ />
        <Contact />
      </main>
    </div>
  );
}
